.filtersContent--dropdown {
  display: var(--haus-filters__filtersContent--dropdown__display, flex);
  flex-direction: var(--haus-filters__filtersContent--dropdown__flex-direction, row);
  flex-wrap: var(--haus-filters__filtersContent--dropdown__flex-wrap, wrap);
  gap: var(--haus-filters__filtersContent--dropdown__gap, 24px);
}

.filtersContent--accordion {
  display: var(--haus-filters__filtersContent--accordion__display, flex);
  flex-direction: var(--haus-filters__filtersContent--accordion__flex-direction, column);
  flex-wrap: var(--haus-filters__filtersContent--accordion__flex-wrap, wrap);
  gap: var(--haus-filters__filtersContent--accordion__gap, 0);
}

.facetDropdowns {
  display: var(--haus-filters__facetDropdowns__display, flex);
  flex-wrap: var(--haus-filters__facetDropdowns__flex-wrap, wrap);
  gap: var(--haus-filters__facetDropdowns__gap, 12px);
}
